<template>
  <div class="field field-tools">
    <div class="level tools is-mobile" ref="tools">
      <div class="level-left">
        <div class="level-item py-2">
          <a @click.prevent="$emit('showEmojis')" :title="`${$modifierKeyEncoded}-E: Insert emoji`">
            <b-icon type="dark" icon="smile"></b-icon>
          </a>
        </div>
        <div class="level-item">
          <a @click.prevent="$emit('addImage')" title="Insert image">
            <b-icon type="dark" icon="images"></b-icon>
          </a>
        </div>
        <div class="level-item">
          <a @click.prevent="showQuoteTweet = true" title="Insert quote tweet">
            <b-icon type="dark" icon="quote-left"></b-icon>
          </a>
        </div>
        <div class="level-item level-grow">
          <transition name="slide-fade" v-on:after-enter="$refs.tweeturl.$refs.inputbox.focus()">
            <div v-if="showQuoteTweet" class="quote-tweet ml-2">
              <tweet-url
                  ref="tweeturl"
                  @blur="showQuoteTweet = false"
                  @tweetValidated="setQuoteTweet"
                  :show-icon="false"
                  :subtle-off-focus="false"
                  placeholder="Enter Twitter URL for a quote retweet..."/>
            </div>
          </transition>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <CharCounter :remaining-chars="remainingChars" :perc="tweetPermillage / 10"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CharCounter from "../CharCounter"
import TweetUrl from "../TweetUrl"

export default {
  name: 'editor-tools',
  components: {CharCounter, TweetUrl},
  props: {
    index: Number,
    remainingChars: Number,
    tweetPermillage: Number,
  },
  data() {
    return {
      showQuoteTweet: false,
    }
  },
  methods: {
    setQuoteTweet(data) {
      this.$store.commit('setQuoteTweet', {
        index: this.index,
        data: data
      });
    }
  }
}
</script>
<style lang="scss">


/* unfortunately hard-coded in to `active` and an A tag so we have to manually use this (see dropdown_item.js.flow L40) */
li.dropdown-item a {
  color: #4a4a4a;
}

.level-left {
  .level-item:not(.level-grow) {
    flex-grow: 0 !important;
  }
}

</style>
